<!-- Header -->
<div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; justify-content: space-between;">
  <div class="flex items-center gap-3">
    <mat-icon style="color: #1C593D; font-size: 24px; width: 24px; height: 24px; flex-shrink: 0;">person</mat-icon>
    <h2 style="font-weight: 700; font-size: 1.05rem; color: #1e5a3f; margin: 0;">Detalle del Beneficiario</h2>
  </div>
  <button type="button" (click)="onNoClick()"
    style="width: 32px; height: 32px; border-radius: 50%; border: 1px solid #d1d5db; background: white; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.2s ease;"
    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280; flex-shrink: 0;">close</mat-icon>
  </button>
</div>

<!-- Contenido -->
<div style="padding: 20px 24px; display: flex; flex-direction: column; gap: 12px;">

  <!-- Tipo de Beneficiario -->
  <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo de Beneficiario</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">
      {{ data.tipoBeneficiarioId === 0 ? 'Persona' : 'Empresa' }}
    </p>
  </div>

  <!-- Identificación -->
  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
    <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo ID</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.tipoID }}</p>
    </div>
    <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Número ID</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.numeroID }}</p>
    </div>
  </div>

  <!-- Nombre / Empresa -->
  <div *ngIf="data.tipoBeneficiarioId === 0" style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
    <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nombres</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.nombre }}</p>
    </div>
    <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Apellidos</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.apellidos }}</p>
    </div>
  </div>
  <div *ngIf="data.tipoBeneficiarioId === 1" style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Nombre de la Empresa</span>
    <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.nombre }}</p>
  </div>

  <!-- Banco y Tipo de Cuenta -->
  <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
    <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Banco</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ data.banco?.nombre }}</p>
    </div>
    <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
      <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo de Cuenta</span>
      <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">
        {{ data.movilPay === 1 ? 'Movil Pay' : data.tipoCuenta?.nombre }}
      </p>
    </div>
  </div>

  <!-- Número de Cuenta -->
  <div style="background: #f9fafb; border-radius: 10px; padding: 12px 16px; border: 1px solid #e5e7eb;">
    <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">
      {{ data.movilPay === 1 ? 'Número de Teléfono' : 'Número de Cuenta' }}
    </span>
    <p style="margin: 2px 0 0; font-size: 0.95rem; font-weight: 700; color: #2563eb; font-family: monospace;">
      {{ data.movilPay === 1 ? '+58 ' + data.numeroCuenta : data.numeroCuenta }}
    </p>
  </div>

</div>

<!-- Footer -->
<div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; justify-content: flex-end;">
  <button type="button" (click)="onNoClick()"
    style="padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
    onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
    Cerrar
  </button>
</div>
